module.exports = __webpack_public_path__ + "static/media/purav_desai.eb333526.jpg";